export default __webpack_public_path__ + "static/media/cryptomonedas.51f1d2ed.png";